import { SkyVueData, StoreFeature } from "../../../core/store/types";

export interface Components extends Array<Component> { }
export type Component = SkyVueComponent | OtherComponent;

export interface SkyVueComponent
{
    slot: string;
    type: string;
    skyVueData?: SkyVueData;
}

export interface OtherComponent
{
    type: string;
    [key: string]: unknown;
}

export const components: StoreFeature<Components> = {};

export function isSkyVueComponent(c: Component): c is SkyVueComponent
{
    return Boolean(c.skyVueData);
}